<form [formGroup]="form">
  <div mat-dialog-actions>
    @if (data.mode === 'create') {
      <h1 mat-dialog-title>New cost override</h1>
    }
    @if (data.mode === 'edit') {
      <h1 mat-dialog-title>Edit cost override</h1>
    }
    <div mat-spacer></div>
    <mat-slide-toggle [formControlName]="'active'" [color]="'accent'" class="mb-3"
      >Active</mat-slide-toggle
      >
    </div>
    <mat-dialog-content flexLayout="row" flexLayoutGap="8px">
      <mat-form-field>
        <mat-label>Opinion Type</mat-label>
        <mat-select
          #select
          multiple
          [value]="selectedCaseTypes$"
          (selectionChange)="caseTypeChanged($event)"
          required [formControlName]="'caseTypeId'">
          <div class="select">
            <mat-checkbox
              color="primary"
              [(ngModel)]="allSelected"
              [ngModelOptions]="{standalone: true}"
              [checked]="allSelected"
            (change)="selectAll($event)">Select All</mat-checkbox>
          </div>
          @for (caseType of data.allCaseTypes; track trackByFn($index, caseType)) {
            <mat-option
              [value]="caseType.caseTypeId"
              >
              {{ caseType.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Fee</mat-label>
        <input matInput min="0" type="number" required [formControlName]="'fee'" />
        @if (form.controls.fee.errors?.min) {
          <mat-error
            >Fee amount can not be less than 0</mat-error
            >
          }
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions [attr.align]="'end'">
        <button mat-flat-button [mat-dialog-close]="{ save: false }">Cancel</button>
        <button
          mat-raised-button
          color="primary"
          [mat-dialog-close]="{ save: true }"
          [disabled]="form.invalid"
          >
          Save
        </button>
      </mat-dialog-actions>
    </form>
